const CryptoJS = require('crypto-js');  //引用AES源码js

// 下面是aes加密解密,CBC模式
const key = CryptoJS.enc.Utf8.parse("jkl;POIU1234++=="); //十六位十六进制数作为秘钥
const iv = CryptoJS.enc.Utf8.parse('ABCDEF1234123412'); //十六位十六进制数作为秘钥偏移量
//加密方法
function aesEncryptCBC(word) {
    let srcs = CryptoJS.enc.Utf8.parse(word);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {iv:iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.ciphertext.toString().toUpperCase();
}
//解密方法
function aesDecryptCBC(word) {
    let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
    let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
    let decrypt = CryptoJS.AES.decrypt(srcs, key, {iv:iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}

// 下面是aes加密解密,ECB模式
const keyECB = CryptoJS.enc.Utf8.parse("nFpT1dAQmTefj0Fk"); //十六位十六进制数作为秘钥
//加密方法
function aesEncryptECB(word) {
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, keyECB, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
}
//解密方法
function aesDecryptECB(word) {
    var decrypt = CryptoJS.AES.decrypt(word, keyECB, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

export default {
  aesEncryptCBC,
  aesDecryptCBC,
  aesEncryptECB,
  aesDecryptECB,
}